<div
  class="collection-container"
  routerLinkActive="router-link-active"
  [ngClass]="{
    'ddc-collection-light': _isLightTheme,
    'ddc-collection-dark': _isDarkTheme,
    'ddc-collection-paper': _isPaperTheme,
  }"
  [routerLink]="[_dynamicRoute]"
>
  <div class="collection-header">
    <div class="collection-title-section">
      <mat-icon class="collection-icon">collections_bookmark</mat-icon>
      <ddc-text-gradient class="collection-title" [_text]="_elem.name" [_type]="'2'"></ddc-text-gradient>
    </div>
  </div>

  <div class="collection-stats-row">
    <div class="stat-item" matTooltip="Words">
      <mat-icon class="stat-icon">fiber_manual_record</mat-icon>
      <span class="stat-count">{{ _elem.words_count || 0 }}</span>
    </div>
    <div class="stat-item" matTooltip="Pairs">
      <mat-icon class="stat-icon">fiber_smart_record</mat-icon>
      <span class="stat-count">{{ _elem.pairs_count || 0 }}</span>
    </div>
    <div class="stat-item" matTooltip="Dictionaries">
      <mat-icon class="stat-icon">auto_stories</mat-icon>
      <span class="stat-count">{{ _elem.dics_count || 0 }}</span>
    </div>
  </div>

  <div class="collection-stats-row">
    <div class="stat-item" matTooltip="Notes">
      <mat-icon class="stat-icon">text_snippet</mat-icon>
      <span class="stat-count">{{ _elem.notes_count || 0 }}</span>
    </div>
    <div class="stat-item" matTooltip="Quizzes">
      <mat-icon class="stat-icon">question_answer</mat-icon>
      <span class="stat-count">{{ _elem.quizzes_count || 0 }}</span>
    </div>
    <div class="stat-item" matTooltip="Figures">
      <mat-icon class="stat-icon">hub</mat-icon>
      <span class="stat-count">{{ _elem.figures_count || 0 }}</span>
    </div>
  </div>

  <div class="collection-preview">
    <span class="preview-text" *ngIf="_elem.elems?.[0]; else emptyPreview">
      {{ _elem.elems[0] }}
    </span>
    <ng-template #emptyPreview>
      <span class="preview-text-empty">No items yet</span>
    </ng-template>
  </div>
</div>
